import { createDependency } from './createDependency';
import { ChannelResolver } from 'core/repositories/ChannelResolver';

export const [useChannelResolver, withChannelResolver] = createDependency<ChannelResolver>();
